export function onIntersect(element, callback, options = {}) {
    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
            callback();
        }
    }, options);
    observer.observe(element);
    return {
        destroy() {
            observer.unobserve(element);
        },
    };
}
